/**
 * Format a phone number to a user-friendly display
 * @param {string} phoneNumber - e.g. '+358447645454' or '0447645421'
 * @param {boolean} international - if true, show with country code
 * @returns {string} formatted number
 */
export function formatPhoneNumber(phoneNumber: string, international: boolean = true) {
  // Remove all non-digit characters, but keep +
  let digits = phoneNumber.replace(/[^\d+]/g, '');

  if (international) {
    // Ensure starts with +358
    if (!digits.startsWith('+')) {
      digits = '+358' + digits.replace(/^0/, '');
    }

    // Split into readable groups: +358 44 764 5443
    return digits.replace(/(\+358)(\d{2})(\d{3})(\d{4})/, '$1 $2 $3 $4');
  } else {
    // Local format (drop country code, keep leading 0)
    let local = digits.replace(/^\+358/, '0');
    // Split: 044 764 5443
    return local.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
  }
}

export function formatName(input: string): string {
  return input.toLowerCase().replace(/\s+/g, '_');
}